import React, { useState } from 'react';
import { 
  Box, 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Alert,
  Container
} from '@mui/material';
import { LockOpen as GuestIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { adminColors, textFieldStyles, buttonStyles } from './adminStyles';

const GuestLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    // Simple hardcoded guest password for now, can be moved to env/secrets later
    if (password === 'guest123') {
      localStorage.setItem('isGuest', 'true');
      navigate('/guest/cv-adaptation');
    } else {
      setError('Mot de passe incorrect');
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      bgcolor: adminColors.bg.page,
      p: 2
    }}>
      <Container maxWidth="xs">
        <Paper sx={{ 
          p: 4, 
          bgcolor: adminColors.bg.surface, 
          borderRadius: 3, 
          border: `1px solid ${adminColors.border.default}`,
          textAlign: 'center'
        }}>
          <GuestIcon sx={{ fontSize: 48, color: adminColors.accent.teal, mb: 2 }} />
          <Typography variant="h5" sx={{ color: 'white', mb: 1, fontWeight: 700 }}>
            Accès Guest
          </Typography>
          <Typography variant="body2" sx={{ color: adminColors.text.secondary, mb: 4 }}>
            Entrez le mot de passe invité pour accéder à l'Adaptateur de CV.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 3, bgcolor: 'rgba(239, 68, 68, 0.1)', color: '#EF4444', border: '1px solid rgba(239, 68, 68, 0.2)' }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              type="password"
              label="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ ...textFieldStyles, mb: 3 }}
              autoFocus
            />
            <Button
              fullWidth
              variant="contained"
              type="submit"
              sx={buttonStyles.primary}
            >
              Se connecter
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};

export default GuestLogin;
